
	
jQuery(document).ready(function($) {	    
    
    jQuery(".go-memoria_llegir_mes").click(function() {
	    $(this).parent().find('.memoria_llegir_mes').show();
	     $(this).parent().find('.go-memoria_llegir_menys').show();
	    
	    $(this).hide();
	     });
	     
	jQuery(".go-memoria_llegir_menys").click(function() {
	    $(this).parent().find('.memoria_llegir_mes').hide();
	    $(this).parent().find('.go-memoria_llegir_mes').show();
	    $(this).hide();
	     });

});